import { render, staticRenderFns } from "./PrijzenDisclaimer.vue?vue&type=template&id=87baf4b4&scoped=true"
import script from "./PrijzenDisclaimer.vue?vue&type=script&lang=js"
export * from "./PrijzenDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./PrijzenDisclaimer.vue?vue&type=style&index=0&id=87baf4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87baf4b4",
  null
  
)

export default component.exports